import React, { useCallback } from 'react';
import { IMenuTranslation, TLanguageIDs } from 'types';
import OutsideFormInput from 'components/Input/OutsideFormInput';
import FullInfoField from 'components/FullInfoField/FullInfoField';

interface IDescriptionTranslationField {
	languageId: TLanguageIDs;
	translations: IMenuTranslation[];
	hasDescriptionFullInfoField?: boolean;
	changeDescriptionTranslation?: (languageId: TLanguageIDs, value: string) => void;
}

export const DescriptionTranslationField: React.FC<IDescriptionTranslationField> = React.memo(
	({ languageId, translations, hasDescriptionFullInfoField, changeDescriptionTranslation }) => {
		const value = translations.find((el) => el.languageId === languageId)?.description || '';

		const handleChange = useCallback(
			(value: string) => {
				changeDescriptionTranslation && changeDescriptionTranslation(languageId, value);
			},
			[changeDescriptionTranslation],
		);

		return (
			<>
				{changeDescriptionTranslation && (
					<OutsideFormInput
						testId="DescriptionTranslationField"
						name="description"
						label="descriptionLabel"
						errorMessage="enterTranslation"
						// withValidation={false}
						maxLength={250}
						value={value}
						onChange={handleChange}
					/>
				)}
				{hasDescriptionFullInfoField && <FullInfoField label="descriptionLabel" value={value || '-'} />}
			</>
		);
	},
);
